
<script setup lang="ts">
// per https://nuxt.com/docs/guide/directory-structure/error
import type { NuxtError } from '#app';

const props = defineProps({
    error: Object as () => NuxtError,
});

const accountContent = getEsNavBarAccountContent();
const globalContent = getEsNavBarGlobalContent();

const errorCode = computed(() => String(props.error?.statusCode));

const footerContent = getEsFooterContent();

</script>

<template>
    <div>
        <es-nav-bar
            :account-content="accountContent"
            :global-content="globalContent">
            <template #logo>
                <ds-es-logo />
            </template>
        </es-nav-bar>
        <nuxt-layout class="error-layout">
            <es-error-page :error-type="errorCode" />
        </nuxt-layout>
        <es-footer :content="footerContent">
            <template #logo>
                <ds-es-logo class="text-white" />
            </template>
        </es-footer>
    </div>
</template>

<style lang="scss">
@use '@energysage/es-ds-styles/scss/variables';
// target so that this override only applies for error layout
.error-layout {
    .body-container {
        .content-container {
            background-color: variables.$gray-50 !important;
        }
    }
}
</style>